import $ from 'jquery';
import * as affix from '@elements/affix';

const AFFIX_MEDIA_QUERY = '(min-width: 992px)';

// Eigene Selektor-Familie statt der Default-Selektoren des Packages: .js-affix__container
// haengt global am <body> (layout.html.twig), die Default-Instanz wuerde den Summary-Inhalt
// sonst mitgreifen. Gleiches Muster wie die Filter-Instanz in scripts/common.js.
// createInitInScope() bewusst auf Modul-Ebene - jede Instanz startet einen eigenen
// requestAnimationFrame-Loop.
const initInScope = affix.createInitInScope(
    {mediaQuery: AFFIX_MEDIA_QUERY},
    {
        base: '.js-checkout-summary-affix',
        placeholder: '.js-checkout-summary-affix__placeholder',
        container: '.js-checkout-summary-affix__container'
    }
);

// Darf pro Mount nur einmal laufen: affix 1.3.x dedupliziert nicht (elements.concat)
// und hat keinen Teardown.
export function initSummaryAffix(element) {
    initInScope($(element));
}

// affix 1.3.x hat kein forceRecalculation() (erst ab 2.x) und keinen ResizeObserver.
// Der debounced resize-Handler des Packages ist der einzige Weg, die min-height des
// Placeholders und isElementTooBig() nach einer Inhaltsaenderung neu zu bewerten.
// Unter 992px bleibt das Event aus: dort wuerde der Handler die min-height des
// aufgeklappten Bodys am Platzhalter einfrieren und das Zuklappen blockieren.
export function recalculateSummaryAffix() {
    if (!window.matchMedia(AFFIX_MEDIA_QUERY).matches) {
        return;
    }

    window.dispatchEvent(new Event('resize'));
}
